import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes";

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;


// import React from "react";
// import { BrowserRouter as Router } from "react-router-dom";
// import AppRoutes from "./routes";
// import Navbar from "./components/navigation/Navbar"


// function App() {
//   return (
//     <Router>
//       <Navbar />
//       <AppRoutes />
//     </Router>
//   );
// }

// export default App;
